const wishlistKey = 'custom_wishlist';

function getWishlist() {
  return JSON.parse(localStorage.getItem(wishlistKey)) || [];
}

function saveWishlist(items) {
  localStorage.setItem(wishlistKey, JSON.stringify(items));
  updateWishlistButtons();
}

function updateWishlistButtons() {
  const wishlist = getWishlist();

  document.querySelectorAll('[data-wishlist]').forEach(button => {
    const exists = wishlist.some(
      item => String(item.id) === String(button.dataset.id)
    );

    button.textContent = exists ? '♥' : '♡';
    button.classList.toggle('active', exists);
  });
}

document.addEventListener('click', function(e) {
  const button = e.target.closest('[data-wishlist]');
  if (!button) return;

  e.preventDefault();
  e.stopPropagation();

  let wishlist = getWishlist();

  const product = {
    id: button.dataset.id,
    title: button.dataset.title,
    url: button.dataset.url,
    image: button.dataset.image,
    price: button.dataset.price
  };

  const index = wishlist.findIndex(
    item => String(item.id) === String(product.id)
  );

  if (index >= 0) {
    wishlist.splice(index, 1);
  } else {
    wishlist.push(product);
  }

  saveWishlist(wishlist);
});

document.addEventListener('DOMContentLoaded', updateWishlistButtons);